import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import { IconButton, Tooltip } from "@mui/material";

interface Props {
  title: string;
  onClick: (anchorEl: HTMLElement) => void;
}

const CardOptionsButton = ({ title, onClick }: Props) => (
  <Tooltip title={title}>
    <IconButton onClick={(event) => onClick(event.currentTarget)}>
      <ChevronRightIcon sx={{ color: "secondary.light" }} />
    </IconButton>
  </Tooltip>
);

export default CardOptionsButton;
